import CompactPDP from "./v1/CompactPDP";
import CompactPDPV2 from "./v2/CompactPDP.v2";
import type { BasePromoBannerProps } from "@/components/PromoBanner/types";

export default function PromoBannerCompactPDP(props: BasePromoBannerProps) {
  return props.compact ? (
    <CompactPDP {...props} />
  ) : (
    <CompactPDPV2 {...props} />
  );
}
